import * as React from "react";
const SvgDragVertical20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "black",
        viewBox: "0 0 24 24"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M8.4 2.8a2.2 2.2 0 1 0 0 4.4 2.2 2.2 0 0 0 0-4.4Zm7.2 0a2.2 2.2 0 1 0 0 4.4 2.2 2.2 0 0 0 0-4.4Zm-7.2 7a2.2 2.2 0 1 0 0 4.4 2.2 2.2 0 0 0 0-4.4Zm7.2 0a2.2 2.2 0 1 0 0 4.4 2.2 2.2 0 0 0 0-4.4Zm-7.2 7a2.2 2.2 0 1 0 0 4.4 2.2 2.2 0 0 0 0-4.4Zm7.2 0a2.2 2.2 0 1 0 0 4.4 2.2 2.2 0 0 0 0-4.4Z",
      clipRule: "evenodd"
    })
  );
export default SvgDragVertical20Px;
